// extracted by mini-css-extract-plugin
export default {"Steps":"Stepper_Steps__R+ABC","stepDot":"Stepper_stepDot__GLROn","stepDotActive":"Stepper_stepDotActive__g4jM2"};